
import {Component, Vue} from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
import SiteServicesForm from "@/form/Settings/site/services";
import {IServicesCategory, IServicesCategoryListItem} from "@/entity/servicesCategory/services.category.types";
import {ServicesCategoryStore} from "@/store/modules/ServicesCategory";
import {RouterNameEnum} from "@/router/router.types";

import {ITableColumn} from "@/entity/table/table.types";
import {TablesStore} from "@/store/modules/Tables";

@Component({
  components: {
    PageTitle, FormGroup
  }
})
export default class Services extends Vue {
  form = new SiteServicesForm();
  modal_form: boolean = false;
  checkRole: boolean = false;
  serviceCategory: IServicesCategoryListItem | null = null;
  categoryId: number = 0;

  columns = [
    {
      dataIndex: 'name',
      key: 'name',
      slots: {title: 'customTitle'},
    },
    {
      title: '',
      dataIndex: 'actions',
      scopedSlots: {customRender: 'operation'},
    },
  ];

  /*customCell = (record: any) => {
    return {
      on: {
        click: (event: any) => {
          console.log('click');
          //this.showModalCategoryEdit(record);
        }
      }
    };
  }*/

  toEditPage(record: any) {
    this.$router.push({name: RouterNameEnum.SettingsSiteServicesEdit, params: {id: record.id}})
  }

  /*customRow = (record: any) => {
    return {
      on: {
        click: (event: any) => {
          let target = event.target;
          if (target.nodeName != 'BUTTON') {
            this.$router.push({name: RouterNameEnum.SettingsSiteServicesEdit, params: {id: record.id}})
          }
        }
      }
    };
  }*/

  // showModalCategoryEdit(serviceCategory: IServicesCategoryListItem): void {
  //   this.serviceCategory = serviceCategory;
  //   this.categoryId = serviceCategory.id;
  //   this.handleUpdateModal(true);
  // }

  // handleUpdateModal(visible: boolean): void {
  //     this.visibleCategoryEdit = visible;
  //     this.serviceUpdateForm.setFormData(this.serviceCategory);
  // }


  async saveSettings(): Promise<void> {


  }

  get columnsServiceCategory(): ITableColumn[] {
    return TablesStore.servicesCategoryColumns;
  }

  get servicesCategoryLoaded(): boolean {
    return ServicesCategoryStore.serviceCategoryLoaded;
  }

  get servicesCategory(): IServicesCategory | null {
    //console.log(ServicesCategoryStore.serviceCategory?.['data'][0].services);
    return ServicesCategoryStore.serviceCategory;
  }

  async created(): Promise<void> {
    this.checkRole = Vue.auth.check('owner');
    let filter = {
      limit: 20,
      filter: {}
    };
    /*if (!this.checkRole) {
      filter.filter = {'is_parent': true}
    }*/
    await ServicesCategoryStore.fetchAll(filter);
  }


}
